import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal modal-sm",
  id: "modal-register"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "modal-alert"
}
const _hoisted_4 = { class: "modal-alert-text" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = { class: "modal-title" }
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_13 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { for: "frm-loginForm_email" }
const _hoisted_16 = { class: "input-wrap icon-login-email" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, null, -1)
const _hoisted_18 = { for: "frm-loginForm_password" }
const _hoisted_19 = { class: "input-wrap icon-login-password" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, null, -1)
const _hoisted_21 = { class: "form-footer is-inline" }
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_24 = { class: "buttons" }
const _hoisted_25 = { class: "button button--primary" }
const _hoisted_26 = { class: "social-login" }
const _hoisted_27 = ["action"]
const _hoisted_28 = { class: "buttons" }
const _hoisted_29 = {
  key: 0,
  class: "button button--google",
  name: "Provider",
  value: "Google"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  class: "button button--facebook",
  name: "Provider",
  value: "Facebook"
}, "Facebook", -1)
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["href", "onClick"]
const _hoisted_34 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.alertText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.alertText), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showCloseButton)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "modal-close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('LoginForm.title')), 1),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('LoginForm.no-account')) + " ", 1),
                _createVNode(_component_router_link, {
                  to: { name: 'RegistrationAgent' },
                  custom: ""
                }, {
                  default: _withCtx(({ navigate, href }) => [
                    _createElementVNode("a", {
                      href: href,
                      class: "weight-medium",
                      onClick: ($event: any) => (_ctx.go($event, navigate))
                    }, _toDisplayString(_ctx.$t('LoginForm.register')), 9, _hoisted_10)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("form", {
                id: "login-form",
                class: "form",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
              }, [
                (_ctx.isError || _ctx.errors.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_ctx.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('LoginForm.email')) + ":", 1),
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                        type: "text",
                        id: "frm-loginForm_email",
                        name: "email",
                        class: "form-control"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.email.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _hoisted_17
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.password.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('LoginForm.password')) + ":", 1),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                        type: "password",
                        id: "frm-loginForm_password",
                        name: "password",
                        class: "form-control"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _hoisted_20
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t('LoginForm.remember-me')) + " ", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.rememberMe.$model) = $event)),
                      type: "checkbox",
                      id: "frm-registerForm_personal-remember-me",
                      name: "personal-remember-me"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.v$.form.rememberMe.$model]
                    ]),
                    _hoisted_23
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.$t('LoginForm.button-login')), 1)
                  ])
                ])
              ], 32),
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.$t('LoginForm.login-with-existing-account')) + " ", 1),
                _createElementVNode("form", {
                  method: "POST",
                  action: _ctx.externalLoginUrl
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    (!_ctx.isFacebookApp)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_29, "Google"))
                      : _createCommentVNode("", true),
                    _hoisted_30
                  ])
                ], 8, _hoisted_27)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", {
                innerHTML: _ctx.$t('LoginForm.general-terms', { generalTermsUrl: _ctx.generalTermsUrl, privacyUrl: _ctx.privacyUrl, domain: _ctx.domain })
              }, null, 8, _hoisted_32),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'ForgotPassword' },
                  custom: ""
                }, {
                  default: _withCtx(({ navigate, href }) => [
                    _createElementVNode("a", {
                      href: href,
                      onClick: ($event: any) => (_ctx.go($event, navigate))
                    }, _toDisplayString(_ctx.$t('LoginForm.button-forgot-password')), 9, _hoisted_33)
                  ]),
                  _: 1
                }),
                _createTextVNode("    |    "),
                _createVNode(_component_router_link, {
                  to: { name: 'RegistrationAgent' },
                  custom: ""
                }, {
                  default: _withCtx(({ navigate, href }) => [
                    _createElementVNode("a", {
                      href: href,
                      onClick: ($event: any) => (_ctx.go($event, navigate))
                    }, _toDisplayString(_ctx.$t('LoginForm.button-register')), 9, _hoisted_34)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}